<template>
  <CommonModal>
    <template slot="header">
      <h3>Update Source TPCD</h3>
    </template>
    <template slot="body">
      <div style="overflow: auto; height: 450px">
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{{tpcdVO.tpcdId}}</td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="tpcdVO.tpcdName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="tpcdVO.tpcdDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="tpcdVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="tpcdVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  getTpcd,
  update,
  checkTpcdNameDuplication,
} from "@/api/tpcd";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      tpcdVO: {
        tpcdId: "",
        tpcdName: "",
        tpcdDesc: "",
        useYn: "Y",
      },
      languages: [],
      tpcd: "",
    };
  },
  methods: {
    async fetchData(id) {
      try {
        const response = await getTpcd(id);
        this.tpcdVO = response.data.tpcd;
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //ControllerTypeName 중복확인
        const { data } = await checkTpcdNameDuplication(this.tpcdVO);
        this.tpcd = data.tpcd;
        if (this.tpcd == null || this.tpcd == "" || this.tpcd.length == 0) {
          try {
            const response = await update(this.tpcdVO);
            return response.data.status;
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
        }
      } else {
        return "alert.plzCheckAllValues";
      }
    },
  },
};
</script>

<style></style>
